// extracted by mini-css-extract-plugin
module.exports = {"checkedValue":"DeclarationInfoSection__checkedValue--1tKoB","contractValue":"DeclarationInfoSection__contractValue--3B-T1"};